import { render } from "./MinistriesList.vue?vue&type=template&id=5b32aa54&scoped=true"
import script from "./MinistriesList.vue?vue&type=script&lang=js"
export * from "./MinistriesList.vue?vue&type=script&lang=js"

import "./MinistriesList.vue?vue&type=style&index=0&id=5b32aa54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b32aa54"]])

export default __exports__